<template>
  <div class="project">
    <div class="project-item">
      <div class="project-item-label">
        项目类型
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ project.typeDesc }}
        </span>
      </div>
    </div>
    <div class="project-item">
      <div class="project-item-label">
        工程名称
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ project.name }}
        </span>
      </div>
    </div>
    <div class="project-item">
      <div class="project-item-label">
        工程地址
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ project.address }}
        </span>
      </div>
    </div>
    <div class="project-item">
      <div class="project-item-label">
        工程规模
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ project.projectSize | formatNumberVal }}&nbsp;{{ project.sizeUnitDesc }}
        </span>
      </div>
    </div>
    <div class="project-item">
      <div class="project-item-label">
        建设单位
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ project.buildDepartment }}
        </span>
      </div>
    </div>
    <div class="project-item">
      <div class="project-item-label">
        总包单位
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ project.totalDepartment }}
        </span>
      </div>
    </div>
    <div class="project-item">
      <div class="project-item-label">
        承(分)包单位
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ project.companyName }}
        </span>
      </div>
    </div>
    <div class="project-item" v-show="!isBuildingCompany">
      <div class="project-item-label">
        承(分)包范围
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ (project.dutyScope || '').split('||').join('、') }}
        </span>
      </div>
    </div>
    <div class="project-item" v-show="isBuildingCompany">
      <div class="project-item-label">
        专业承包类别
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ project.majorContractTypeDesc }}
        </span>
      </div>
    </div>
    <div class="project-item">
      <div class="project-item-label">
        开工日期
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ project.planStartupTime | formatDateValue }}
        </span>
      </div>
    </div>
    <div class="project-item">
      <div class="project-item-label">
        竣工日期
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ project.planCompletedTime | formatDateValue }}
        </span>
      </div>
    </div>
    <div class="project-item">
      <div class="project-item-label">
        质量标准
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ project.qualityStandardDesc }}
        </span>
      </div>
    </div>
    <div class="project-item">
      <div class="project-item-label">
        工程说明
      </div>
      <div class="project-item-text">
        <span class="project-item-text-wrap">
          {{ project.remark }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import currency from 'currency.js';
import { dateFormat } from '@/util/dateUtils';

export default {
  props: ['project', 'isBuildingCompany'],
  data() {
    return {
    };
  },
  filters: {
    formatDateValue: value => dateFormat(value),
    formatNumberVal: (value) => {
      if (value) {
        return currency(value).format();
      }
      return '--';
    },
    formatPriceVal: (value) => {
      if (value) {
        return currency(value).format();
      }
      return '面议';
    },
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .project {
    padding: 0rem 0.5rem;
  }

  .project-item {
    font-size: 1rem;
    display: flex;
    align-items: flex-start;
    width: 100%;
    padding: 0.5rem 0rem;
    border-bottom: 0.05rem solid $border-color;
  }

  .project-item:last-child {
    border-bottom: none;
  }

  .project-item-label {
    white-space: nowrap;
    color: $font-color;
    padding-right: 0.5rem;
  }

  .project-item-text {
    text-align: right;
    flex: auto;
    color: $second-font-color;
  }

  .project-item-text-wrap {
    text-align: left;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectView.vue